<template>
	<div class="image-text slider">
		<div class="text">
			<div
				v-for="(item, index) in items"
				:key="item.slug"
				class="text-slide"
				:class="{ active: currentItemIndex === index }">
				<p class="page">{{ pad(index + 1, 2) }} / {{ pad(items.length, 2) }}</p>
				<div v-html="item.content"></div>
			</div>
			<div class="arrows">
				<svg @click="previousSlide()" xmlns="http://www.w3.org/2000/svg" width="46.575" height="34.152" viewbox="0 0 46.575 34.152"><path d="M46.575 16.898h-45m16.209 16.547L1.415 17.076 17.784.707" fill="none" stroke="currentColor" stroke-width="2"/></svg>
				<div class="px-2"></div>
				<svg @click="nextSlide()" xmlns="http://www.w3.org/2000/svg" width="46.575" height="34.152" viewbox="0 0 46.575 34.152"><path d="M0 17.254h45M28.791.707 45.16 17.076 28.791 33.445" fill="none" stroke="currentColor" stroke-width="2"/></svg>
			</div>
		</div>
		<div class="spacer"></div>
		<div class="image right">
			<img
					v-for="(item, index) in items"
					:key="item.slug"
					:class="{ active: currentItemIndex === index }"
					:src="item.image.url" alt="Slider image">
		</div>
	</div>
</template>

<script>
import {LoadApiData} from '../modules/api.js';

export default {
	props: {
		collection: {
			type: String
		}
	},
	data() {
		return {
			items: [],
			currentItemIndex: 0,
		};
	},
	methods: {
		pad: (number, digits) => {
			number = String(number);
			return number.length >= digits ? number : new Array(digits - number.length + 1).join('0') + number;
		},
		previousSlide() {
			this.currentItemIndex = (this.currentItemIndex > 0) ? this.currentItemIndex - 1 : this.items.length - 1;
		},
		nextSlide() {
			this.currentItemIndex = (this.currentItemIndex < this.items.length - 1) ? this.currentItemIndex + 1 : 0;
		}
	},
	mounted: function () {
		let context = this;
		let parentElement = this.$el.parentElement;

		parentElement.classList.add('full-width', 'dark');

		const api = `/api/collections/${this.collection}/entries`;
		const fields = ['slug', 'title', 'image', 'content'].join(',');
		LoadApiData(api, fields, '&sort=slug', (response) => {
			context.items = response.data;
		});
	}
};
</script>

<style scoped>

</style>
